module.exports = __webpack_public_path__ + "img/21_15.7e19b305.png";